export default __webpack_public_path__ + "static/media/wrapping-paper.dc4b40e4.png";